// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/solid/calendar.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/solid/calendar'

import { Icon, type IconComponentProps } from '../icon'

export const CalendarIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
